import React, {useEffect, useState} from "react";
import {Select} from "antd";
import {WidgetProps} from "../../../../../common/ui/input/widget/widget";
import {HealthCheckerGroupOption} from "../../../../../../models/health-checker/health-checker";
import {healthCheckerService} from "../../../../../../services/health-checker/health-checker.service";

export const UIInputWidgetHealthCheckerGroup: React.FC<WidgetProps> = ({value, onChange, multiple, loading}) => {
    const [groups, setGroups] = useState<HealthCheckerGroupOption[]>([]);
    const [groupsLoading, setGroupsLoading] = useState(false);

    useEffect(() => {
        setGroupsLoading(true);
        healthCheckerService
            .getAllGroups()
            .then(setGroups)
            .finally(() => setGroupsLoading(false));
    }, []);

    return (
        <Select
            mode={multiple ? "multiple" : undefined}
            onChange={onChange as any}
            value={value as any}
            allowClear
            showSearch
            optionFilterProp="children"
            loading={loading || groupsLoading}
        >
            {groups.map((group) => (
                <Select.Option key={group.id} value={group.id}>
                    {group.name}
                </Select.Option>
            ))}
        </Select>
    );
};
